import React from 'react';

const VARIANTS = {
  primary:   'btn-primary',
  secondary: 'btn-secondary',
  sand:      'btn-sand',
  danger:    'btn-danger',
  success:   'btn-success',
  ghost:     'btn-ghost',
};
const SIZES = { sm: 'btn-sm', md: '', lg: 'btn-lg' };

export default function Button({ children, variant = 'primary', size = 'md', disabled, loading, onClick, type = 'button', className = '' }) {
  return (
    <button type={type} onClick={onClick} disabled={disabled || loading}
      className={`btn ${VARIANTS[variant] || VARIANTS.primary} ${SIZES[size]} ${className}`}>
      {loading ? (
        <>
          <svg className="animate-spin w-3.5 h-3.5" fill="none" viewBox="0 0 24 24">
            <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
            <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8z" />
          </svg>
          Laden…
        </>
      ) : children}
    </button>
  );
}
